import trackingUtils from './utils'

const UserTrackingUtils = {
  install(Vue) {
    Vue.prototype.$trackingUtils = trackingUtils
  },
}

export default UserTrackingUtils
